import React from 'react'
import { connect } from 'react-redux'
import { Dropdown } from 'semantic-ui-react'

const data1 = [
  {"text": "هفته اول", "value": 1, "key": 1},
  {"text": "هفته دوم", "value": 2, "key": 2},
  {"text": "هفته سوم", "value": 3, "key": 3},
  {"text": "هفته چهارم", "value": 4, "key": 4},
]
const data2 = [
  {"text": "فصل", "value": 0, "key": 0},
]

class WeekSelect extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      data: data1,
      selected: '',
      loading: false,
      defaultValue: this.props.defaultValue,
      type: 1,
    };

  }

  // componentWillMount() {
  //   this.getData()
  // }

  // async getData() {

  //   this.setState({ loading: true })

  //   await travelBrandsService.getAll()
  //     .then((res) => {
  //       let arr = res.data;
  //       // console.log(arr);
  //       var items = [];
  //       for (var i = arr.length; i--;) {
  //         var obj = arr[i];
  //         obj.key = obj.travelBrandId;
  //         obj.value = obj.travelBrandId;
  //         obj.text = obj.name;
  //         items.push(obj)
  //       }

  //       this.setState({ data: arr, loading: false });

  //     })
  //     .catch((error) => {
  //       this.setState({ loading: false })
  //     });

  // };

  async componentWillReceiveProps(nextProps) {
    if (nextProps.defaultValue !== this.state.defaultValue) {
      this.setState({ defaultValue: nextProps.defaultValue });
    }
    if (nextProps.type !== this.state.type) {
      this.setState({ type: nextProps.type, data: nextProps.type == 1 ? data1 : data2 });
    }
  }

  // shouldComponentUpdate(nextProps){
  //   return true;
  // }

  handleChange = (e) => {

    let selected = e;
    this.setState({ selected: selected })
    this.props.onChange(selected)

  }



  render() {

    const { data, loading, defaultValue } = this.state;
    const { clearable, disabled } = this.props;

    return (
      <Dropdown
        placeholder='دوره'
        fluid
        search
        selection
        basic
        onChange={(e, data) => this.handleChange(data.value)}
        value={defaultValue}
        className="semantic-select-box"
        options={data}
        wrapSelection={false}
        selectOnBlur={false}
        searchInput={{ autoFocus: false }}
        loading={loading}
        disabled={disabled}
        clearable={clearable}
      />
    );
  }
}

function mapStateToProps(state) {
  const { authentication } = state;
  const { user } = authentication;
  return {
    user
  };
}

const connectedWeekSelect = connect(mapStateToProps)(WeekSelect);
export { connectedWeekSelect as WeekSelect };